import { Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { AuthService } from 'src/app/services/auth.service';
import { Component } from '@angular/core';
@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent {
  showStories : boolean = true;
  public appPages = [
    // { title: 'Dashboard', url: '/dashboard', icon: 'stats-chart' },
    { title: 'Users', url: '/users', icon: 'person' },
    { title: 'Scores', url: '/scores', icon: 'bar-chart' },
    { title: 'Messages', url: '/messages', icon: 'mail' },

  ];






  constructor(
    private auth: AuthService,
    private cookieService: CookieService,
    private router: Router
  ) {
    this.auth.checkAuthState();
  }

  logOut() {
    this.cookieService.deleteAll();
    console.log("Del");
    
    this.router.navigate(['/login'], { replaceUrl: true });
  }
}
